import React from "react";

const CustomDropdown = ({
  errorObj,
  label,
  options,
  selectedValue,
  selectedSegment,
  setSelectedValue,
}) => {
  return (
    <div className="col-md-12">
      <div className="form-group mb-3">
        <label className="mb-2 ct_fw_600">{label}</label>
        <select
          className="form-control"
          value={selectedValue}
          onChange={(e) => setSelectedValue(e.target.value)}
        >
          <option value="">Select {label}</option>
          {options?.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
      {errorObj[selectedSegment] && (
        <span style={{ color: "red" }}>{errorObj[selectedSegment]}</span>
      )}
    </div>
  );
};

export default CustomDropdown;
